/**
 * Calculate url in case of null value for provider
 * @param {String} url 
 * @param {Object} state 
 */
export function getValidUrl(url, state) {
    const nullPrReg = /provider\/(.*?)\//g.exec(url)
    const matchGr = (nullPrReg && Array.isArray(nullPrReg)) ? nullPrReg[1] : null
    const provider = state.provider.providers.length > 0 ?  state.provider.providers[0].provider : null
    if(matchGr === "null" && provider) {
        url = url.replace('/null/', '/' + provider + '/')
    }
    if (state.userType === 'observer' && !url.includes('/user') && !url.includes('/import'))
        url = url.replaceAll('provider', 'safe')
    return url
}

export function getfilterDataForDate(row, state) {
    if (!row) return []
    const start = state.filterTimestamp.startDate, end = state.filterTimestamp.endDate

    if(start && end) {
        return row.filter(elem => elem.created >= start && elem.created <= end)
    } else if(start && !end) {
        return row.filter(elem => elem.created >= start)
    } else if(!start && end) {
        return row.filter(elem => elem.created <= end)
    } else {
        return row
    }
}

export function getErrorMessage(arr = []) {
    const errorTypeMap = {
        data: "time, date, email, phone, doctor and appointment",
        problem: "problem",
        solution: "solution",
        action: "action",
        provider: "doctor",
        source: "source",
        event: "appointment",
        name: "name",
        email: "email",
        time: "time"
    }
    const str = arr.map((elm) => {
        const err = elm.split(":")[0]
        return errorTypeMap[err]
    })
    return `Error resolution failed. Please enter correct ${str.join(", ")}.`
}